import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class OrderTypeTabChangeService {

  private source = new BehaviorSubject<number>(null);
  current = this.source.asObservable();

  constructor() {}

  changeTab(tabId){
    this.source.next(tabId);
  }

}
